import React from 'react'

import Input from "../../../../../../../core/gd-form/form-element/input/input"
import ProjectColor from "../../../../../../../core/gd-form/form-element/project-color/project-color";
import FormError from "../../../../../../../core/gd-form/common/form-error/form-error"
import FormManager from "../../../../../../../core/gd-form/common/form-manager"
import FormModel from "../../../../../../../core/gd-form/common/form-model-manager";

type Props = {
    form: FormManager | FormModel
}

export default function FormNameColorSelector(props: Props) {
    return (
        <div className="row">
            <div className="label">Name</div>
            <div className="element name-color-container">
                <Input size="big"
                       form={props.form}
                       name="name"
                       className="with-color" />

                <ProjectColor name="color" form={props.form} />

                <FormError form={props.form} name="name" />
                <FormError form={props.form} name="color" />
            </div>
        </div>
    )
}
